import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import {
  createVenuesCollection,
  deleteVenuesCollection,
  updateVenuesCollection,
} from '../../../store/VenuesCollectionReducer'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

export const VenuesCollectionForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const { error } = useAppSelector((state) => state.venuesCollection)
    const dispatch = useAppDispatch()

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          update: Update,
          delete: Delete,
        }}
        handlers={{
          create: async (values) =>
            dispatch(createVenuesCollection(values)).then(() => {
              return true
            }),
          update: async (values) =>
            dispatch(updateVenuesCollection(values)).then(() => {
              return true
            }),
          delete: async (values) =>
            dispatch(deleteVenuesCollection(values)).then(() => {
              return true
            }),
        }}
      />
    )
  }
)

VenuesCollectionForm.displayName = 'VenuesCollectionForm'

export default VenuesCollectionForm
